/**
 * Navigation Backdrop Module
 * Shows a backdrop overlay when any dropdown menu is hovered
 */

export const navBackdrop = {
    hideTimeout: null,

    init() {
        // Only run on desktop (lg breakpoint)
        if (window.innerWidth < 1024) return;

        const backdrop = document.getElementById('nav-backdrop');
        if (!backdrop) return;

        // Get all dropdown menu items with group classes
        const dropdownGroups = document.querySelectorAll(
            '.group\\/diensten, .group\\/branches, .group\\/themas, .group\\/inspiratie, .group\\/overchangekitchen'
        );

        if (dropdownGroups.length === 0) return;

        // Add hover event listeners to each dropdown group
        dropdownGroups.forEach(group => {
            group.addEventListener('mouseenter', () => {
                if (window.innerWidth >= 1024) {
                    // Clear any pending hide timeout
                    if (this.hideTimeout) {
                        clearTimeout(this.hideTimeout);
                        this.hideTimeout = null;
                    }
                    
                    backdrop.classList.remove('opacity-0', 'invisible');
                    backdrop.classList.add('opacity-100');
                }
            });

            group.addEventListener('mouseleave', () => {
                if (window.innerWidth >= 1024) {
                    // Add delay before hiding the backdrop
                    this.hideTimeout = setTimeout(() => {
                        backdrop.classList.remove('opacity-100');
                        backdrop.classList.add('opacity-0', 'invisible');
                    }, 200); // 200ms delay
                }
            });
        });

        // Handle window resize
        window.addEventListener('resize', () => {
            if (window.innerWidth < 1024) {
                if (this.hideTimeout) {
                    clearTimeout(this.hideTimeout);
                    this.hideTimeout = null;
                }
                backdrop.classList.remove('opacity-100');
                backdrop.classList.add('opacity-0', 'invisible');
            }
        });
    }
};

